import { createSlice } from '@reduxjs/toolkit'
import { ROLE_USER, USER_TYPE } from 'constant/common'
import { removeCookie } from 'utils/cookie'

export interface IUserState {
  code?: string
  role?: string
  id?: number
  isMessageUnread?: string
  isNoticeUnread?: string
  userInfo?: any
  time?: any
}

const initialState: IUserState = {
  role: undefined,
  id: undefined,
  isMessageUnread: undefined,
  isNoticeUnread: undefined,
  userInfo: undefined,
  time: new Date()
}

const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    changeRole: (state, action) => {
      state.role = action.payload
    },
    storeUser: (state, action) => {
      state.userInfo = action.payload.value
      state.id = action.payload.id
      // role b2b = employee
      if (action.payload.value?.fwscrm_userType === USER_TYPE.employee) {
        action.payload.value.role = ROLE_USER.employee
        localStorage.setItem('role-user', ROLE_USER.employee)
      } else if (action.payload.value?.fwscrm_userType === USER_TYPE.staff) {
        action.payload.value.role = ROLE_USER.staff
        localStorage.setItem('role-user', ROLE_USER.staff)
      } else if (action.payload.value?.fwscrm_userType === USER_TYPE.test) {
        action.payload.value.role = ROLE_USER.staff
        localStorage.setItem('role-user', ROLE_USER.staff)
      }
      // return action.payload
    },
    storeTime: (state, action) => {
      state.time = action.payload
    },
    getUser: (state) => {
      return state
    },
    getTime: (state) => {
      return state.time
    },
    setIdCurrent: (state, action) => {
      state.id = action.payload
    },
    setIsMessageUnread: (state, action) => {
      state.isMessageUnread = action.payload
    },
    setIsNoticeUnread: (state, action) => {
      state.isNoticeUnread = action.payload
    },
    clearUser: () => {
      removeCookie('access_token')
      localStorage.removeItem('role')
      return initialState
    }
  }
})

export default userSlice
